
// 연동 서버
// 메일 서버 설정
//
// @since 2018-12-05
// @author 이기환 (devp026)

const initMailServerData = () => {
  return {
    system_smtp_enable_yn: 0,
    system_smtp_secure_conn: 0,
    system_smtp_sender_mail: '',
    system_smtp_server_addr: '',
    system_smtp_server_port: 587,
    system_smtp_use_auth_yn: 0,
    system_smtp_user_id: '',
    system_smtp_user_pwd: ''
  }
}
export const state = () => ({
  url: '/api/sm/external/smtp',
  mailServerOrgData: {},
  mailServerDataConfig: initMailServerData()
})

export const mutations = {
  setMailServerDataConfig (state, data) {
    state.mailServerDataConfig = data
  }
}

export const actions = {
  async applySmtpSettingsAction () {
    const result = await this.$axios.$put('/api/sm/external/smtp/apply', null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelSmtpSettingsAction () {
    const result = await this.$axios.$put(`/api/sm/external/smtp/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  async setMailServerData ({commit, state}) {
    let param = state.mailServerDataConfig
    if (param.system_smtp_enable_yn === 0) {
      const mailAddr = param.system_smtp_sender_mail
      param = initMailServerData()
      param.system_smtp_sender_mail = mailAddr
    }
    const result = await this.$axios.$post(state.url, param, {loading: false, successAlert: false})
    return result
  },
  async getMailServerData ({commit, state}) {
    const result = await this.$axios.$get(state.url)
    if (result.code === 'ok') {
      commit('setMailServerDataConfig', result.result)
    }
    return result
  }
}
export const strict = false
